import { createSelector } from 'reselect';
import { Global } from '../state/Global';
import _get from 'lodash/get';

/**
 * Direct selector to the recordings state domain
 */
const selectRecordingsState = (state: Global) => state.app.get('recordings', null);
const selectRecordingFetching = (state: Global) => _get(state, 'nucleus.recordings.cloudInfo.isFetching');

const selectIsGridLayout = createSelector(
  selectRecordingsState,
  (recordings) => {
    return recordings.isGridLayout;
  }
);
const selectPageNum = createSelector(
  selectRecordingsState,
  (recordings) => {
    return recordings.pageNum;
  }
);
const selectSortBy = createSelector(
  selectRecordingsState,
  (recordings) => {
    return recordings.sortBy;
  }
);
const selectTimeline = createSelector(
  selectRecordingsState,
  (recordings) => {
    return recordings.timeline;
  }
);

const selectSearchResults = createSelector(
  selectRecordingsState,
  (recordings) => {
    return recordings.searchResults;
  }
);

const recordingResultsPendingSelector = createSelector(
  selectRecordingsState,
  selectRecordingFetching,
  (recordings, isFetching) => {
    return recordings.pending || isFetching;
  }
);

const getUploadsStatus = createSelector(
  selectRecordingsState,
  (recordings) => {
    return recordings.uploadsStatus;
  }
);

export {
  selectIsGridLayout,
  selectPageNum,
  selectSortBy,
  selectTimeline,
  selectSearchResults,
  recordingResultsPendingSelector,
  getUploadsStatus
};
